module.exports = __webpack_public_path__ + "img/22200.9639a9f2.jpg";